import { useQuery } from '@tanstack/react-query'
import { dealerService } from '../services/dealer.service'

export const dealerQueryKeys = {
  dashboard: ['dealer', 'dashboard'] as const,
  vehicles: ['dealer', 'vehicles'] as const,
  parts: ['dealer', 'parts'] as const,
  usage: ['dealer', 'usage'] as const,
  subscription: ['dealer', 'subscription'] as const,
  permissions: ['dealer', 'permissions'] as const,
}

export function useDealerDashboard() {
  return useQuery({
    queryKey: dealerQueryKeys.dashboard,
    queryFn: dealerService.getDashboard,
  })
}

export function useDealerVehicles() {
  return useQuery({
    queryKey: dealerQueryKeys.vehicles,
    queryFn: dealerService.getVehicles,
  })
}

export function useDealerParts() {
  return useQuery({
    queryKey: dealerQueryKeys.parts,
    queryFn: dealerService.getParts,
  })
}

export function useDealerUsage() {
  return useQuery({
    queryKey: dealerQueryKeys.usage,
    queryFn: dealerService.getUsage,
  })
}

export function useDealerSubscription() {
  return useQuery({
    queryKey: dealerQueryKeys.subscription,
    queryFn: dealerService.getSubscription,
  })
}

export function useDealerPermissions() {
  return useQuery({
    queryKey: dealerQueryKeys.permissions,
    queryFn: dealerService.getPermissions,
  })
}
